import React, { useState } from "react";

import moment from "moment";

import "./times-new-roman-reg.ttf";

const Printdoc = ({ orderDetail, edit, view, upload, pharmacy, printt }) => {
  console.log("orderdetaill pharmacy?.delivered_bypharmacy?.delivered_by", pharmacy, orderDetail, printt);
  const [imageError, setImageError] = useState(false);

  const styles = {
    page: {
      width: printt ? "7.7in" : "6.2in",
      height: "9.25in",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      fontFamily: "Times New Roman, sans-serif",
      color: "black",
      backgroundColor: "white",
      padding: "10px",
      paddingTop: "40px",
    },
    pageHead: {
      display: "flex",
      justifyContent: "space-between",
      fontFamily: "Times New Roman, sans-serif",
      fontSize: "12px",
    },
    pageMainText: {
      textAlign: "center",
      fontSize: "12px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      fontFamily: "Times New Roman, sans-serif",
    },
    bar: {
      height: "2.5px",
      widht: "100%",
      backgroundColor: "black",
    },
    bar2: {
      height: "1px",
      widht: "100%",
      backgroundColor: "black",
      marginTop: "15px",
    },
    orderDetail: {
      fontWeight: "400",
      fontSize: "12px",
      width: "50%",
      marginLeft: "5px",
      fontFamily: "Times New Roman, sans-serif",
    },
    orderList: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "15px",
      marginRight: "50px",
    },
    orderResult: {
      display: "flex",
      justifyContent: "space-between",
      marginLeft: "20px",
      marginRight: "80px",
      marginTop: "5px",
      fontWeight: "800",
      fontSize: "12px",
    },
    orderBottom: {
      display: "flex",
      justifyContent: "space-between",
      marginLeft: "20px",
      marginTop: "20px",
      marginRight: "30px",
      fontSize: "12px",
    },
  };

  console.log("orderDetailorderDetailorderDetail", orderDetail);

  return (
    <>
      <div style={styles.page}>
        <div style={styles.pageHead}>
          <p>Date: {moment(orderDetail.createdAt).format("MM/DD/YYYY")}</p>
          <h1 style={{ fontWeight: "700", fontSize: "12px" }}>
            {pharmacy?.name}
          </h1>
          <p>Page 1/1</p>
        </div>
        <div style={styles.pageMainText}>
          <h1 style={{ fontWeight: "700", fontSize: "12px" }}>
            {pharmacy?.location}
          </h1>
          <h1 style={{ fontWeight: "500", fontSize: "12px" }}>
            Phone:{" "}
            <span style={{ fontWeight: "700", marginLeft: "7px" }}>
              {pharmacy?.contact_no}
            </span>
            <span style={{ marginLeft: "10px" }}>
              Fax:{" "}
              <span style={{ fontWeight: "700", marginLeft: "7px" }}>
                {pharmacy?.fax_number}
              </span>
            </span>
          </h1>
          <div
            style={{
              display: "inline-block",
              border: "3px solid black",
              marginTop: "3px",
              marginBottom: "7px",
              boxShadow: "3px 3px 0px black",
              position: "relative",
            }}
          >
            <div
              style={{
                textAlign: "center",
                fontWeight: 800,
                fontSize: "12px",
                width: "160px",
                padding: "2px",
              }}
            >
              Delivery Slip
            </div>
          </div>
        </div>
        <div style={styles.bar} />
        <div style={styles.orderDetail}>
          <h1
            style={{
              fontWeight: "700",
              fontSize: "12px",
              textAlign: "left",
              textDecoration: "underline",
              marginTop: "1%",
            }}
          >
            CLIENT:
          </h1>
          <h1 style={{ fontWeight: "800", fontSize: "12px", textAlign: "left" }}>
            {orderDetail.name}
          </h1>
          <p style={{ textAlign: "left", marginTop: "1.5%", fontSize: "12px" }}>
            {orderDetail.address}
          </p>
          <p style={{ textAlign: "left", fontSize: "12px" }}>
            Phone# : {orderDetail.contact}
          </p>
          <p style={{ textAlign: "left", fontSize: "12px" }}>
            Cell# : {orderDetail.cellNumber}
          </p>
          <p style={{ textAlign: "left", fontSize: "12px" }}>
            Work# :{" "}
            {orderDetail.workNumber === undefined ||
              orderDetail.workNumber === "undefined"
              ? ""
              : orderDetail.workNumber}
          </p>
        </div>
        <div style={styles.orderList}>
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: "5px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    borderBottom: "1px solid black",
                    fontSize: "12px",
                    width: "60px",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    borderBottom: "1px solid black",
                    fontSize: "12px",
                    width: "120px",
                  }}
                >
                  Rx. Barcode
                </th>
                <th
                  style={{
                    borderBottom: "1px solid black",
                    fontSize: "12px",
                    width: "100px",
                  }}
                >
                  Rx. #
                </th>
                <th
                  style={{
                    borderBottom: "1px solid black",
                    fontSize: "12px",
                    width: "40px",
                  }}
                >
                  Rf. #
                </th>
                <th />
                <th style={{ width: "70px" }} />
                <th />
                <th
                  style={{
                    borderBottom: "1px solid black",
                    fontSize: "12px",
                    width: "50px",
                  }}
                >
                  Qty
                </th>
                <th
                  style={{
                    borderBottom: "1px solid black",
                    fontSize: "12px",
                    width: "80px",
                  }}
                >
                  Copay
                </th>
              </tr>
            </thead>
            <tbody>
              {edit
                ? orderDetail.orderdetail.map((rxOrder, i) => (
                  <tr style={{ fontSize: "12px", textAlign: "center" }}>
                    <td>{rxOrder.date}</td>
                    <td style={{ width: "120px" }}>
                      {rxOrder.barcode_image && !imageError && (
                        <img
                          style={{ height: "20px", maxWidth: "90px" }}
                          src={rxOrder.barcode_image}
                          alt="bar-code"
                          onError={() => setImageError(true)}
                        />
                      )}
                    </td>{" "}
                    <td>{rxOrder.rxnumber}</td>
                    <td>{rxOrder.rfnumber}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{rxOrder.quantity}</td>
                    <td>{rxOrder.copay}</td>
                  </tr>
                ))
                : view
                  ? orderDetail.orderdetail.map((rxOrder, i) => (
                    <tr style={{ textAlign: "center" }}>
                      <td>{rxOrder.date}</td>
                      <td style={{ width: "120px" }}>
                        {rxOrder.barcode_image && !imageError && (
                          <img
                            style={{ height: "20px", maxWidth: "90px" }}
                            src={rxOrder.barcode_image}
                            alt="bar-code"
                            onError={() => setImageError(true)}
                          />
                        )}
                      </td>{" "}
                      <td>{rxOrder.rxnumber}</td>
                      {/* <td style={{ borderBottom: '1px solid black', maxWidth: '200px' }}><Barcode value={extractNumberAfterHyphen(rxOrder.rxnumber)} displayValue="false" width="2" format="CODE128" height="20px" /></td> */}
                      <td>{rxOrder.rfnumber}</td>
                      {/* <td style={{ borderBottom: '1px solid black', maxWidth: '70px' }}></td> */}
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{rxOrder.quantity}</td>
                      <td>{rxOrder.copay}</td>
                    </tr>
                  ))
                  : orderDetail.orderdetail.map((rxOrder, i) => (
                    <tr style={{ textAlign: "center" }}>
                      <td>{rxOrder.date}</td>
                      <td style={{ maxWidth: "70px" }}>
                        {rxOrder.barcode_image && !imageError && (
                          <img
                            style={{ height: "12px" }}
                            src={rxOrder.barcode_image}
                            alt="bar-code"
                            onError={() => setImageError(true)}
                          />
                        )}
                      </td>
                      <td>{rxOrder.rxnumber}</td>
                      {/* <td style={{ borderBottom: '1px solid black', maxWidth: '200px' }}><Barcode value={extractNumberAfterHyphen(rxOrder.rxnumber)} displayValue="false" width="2" format="CODE128" height="20px" /></td> */}
                      <td>{rxOrder.rfnumber}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{rxOrder.quantity}</td>
                      <td>{rxOrder.copay}</td>
                    </tr>
                  ))}
              {/* Add more <tr> elements for additional rows */}
            </tbody>
          </table>
        </div>
        <div style={styles.bar2} />
        <div style={styles.orderResult}>
          <p style={{ fontSize: "12px", fontWeight: "500" }}>
            Total Rx Count :{" "}
            {view
              ? orderDetail.orderdetail.length
              : orderDetail.orderdetail.length}
          </p>
          <p style={{ fontSize: "12px", fontWeight: "500" }}>
            Total Pat. Amt: $
            {edit
              ? orderDetail.orderdetail
                .reduce((total, rx) => total + parseFloat(rx.copay), 0)
                .toFixed(2)
              : view
                ? orderDetail.orderdetail
                  .reduce(
                    (total, rx) => total + parseFloat(rx.copay),
                    0
                  )
                  .toFixed(2)
                : orderDetail.orderdetail
                  .reduce(
                    (total, rx) => total + parseFloat(rx.copay),
                    0
                  )
                  .toFixed(2)}
          </p>
        </div>
        <div
          style={{
            margin: "10px",
            display: "flex",
            justifyContent: "space-between",
            marginLeft: "20px"
          }}
        >
          {/* <div>
              <p style={{fontSize: "12px"}}>Patient is requesting Counseling: Yes ___ No ___</p>
              <p style={{fontSize: "12px", marginTop: "15px"}}>Receiver's Name: ______________________________</p>
              <p style={{fontSize: "12px", marginTop: "15px"}}>Receiver's Signature: __________________________</p>
            </div>
            <div>
              <p style={{fontSize: "12px", marginTop: "15px"}}>Date: ____________ Time: ____________</p>
              <p style={{fontSize: "12px", marginTop: "15px"}}>Delivered By: ______________________________</p>
            </div> */}
        </div>
        <div></div>
        {!upload && edit && orderDetail.status === "5" && (
          <>
            <p
              style={{
                marginLeft: "20px",
                marginBottom: "5px",
                fontSize: "12px",
                textAlign: "left",
              }}
            >
              Patient is requesting Counseling:
              <span style={{ marginLeft: "10px" }}>
                Yes:{" "}
                <span style={{ borderBottom: "1px solid black" }}>
                  {orderDetail.requestCouncelling ? "✓" : " "}
                </span>
              </span>
              <span style={{ marginLeft: "10px" }}>
                No:{" "}
                <span style={{ borderBottom: "1px solid black" }}>
                  {!orderDetail.requestCouncelling ? "✓" : " "}
                </span>
              </span>
            </p>
            <p
              style={{
                marginLeft: "20px",
                marginRight: "30px",
                fontSize: "12px",
                textAlign: "left",
              }}
            >
              {pharmacy?.is_hippa_note && pharmacy?.hippa_notes === null
                ? `I certify that I requested and received my medication listed above from ${pharmacy.name} Pharmacy (${pharmacy.location} - the "Pharmacy"). I further certify that I have a patient relationship with the ordering medical provider indicated on the prescription label and that I requested that the prescriber send this prescription to the Pharmacy. The foregoing is certified as true and accurate under the penalty of perjury.`
                : pharmacy?.hippa_notes}
            </p>
            <div style={styles.orderBottom}>
              <p>
                Receiver Name{" "}
                <span
                  style={{
                    paddingLeft: "30px",
                    fontWeight: "800",
                    paddingRight: "30px",
                    borderBottom: "1px solid black",
                  }}
                >
                  {orderDetail.name}
                </span>
              </p>
              <div style={{ display: "flex" }}>
                <p>
                  Date{" "}
                  <span
                    style={{
                      paddingLeft: "10px",
                      fontWeight: "800",
                      paddingRight: "10px",
                      borderBottom: "1px solid black",
                    }}
                  >
                    {moment(orderDetail.deliverAt).format("MM/DD/YYYY")}
                  </span>
                </p>
                <p>
                  Time{" "}
                  <span
                    style={{
                      paddingLeft: "10px",
                      fontWeight: "800",
                      paddingRight: "10px",
                      borderBottom: "1px solid black",
                    }}
                  >
                    {moment(orderDetail.deliverAt).format("hh:mm:ss a")}
                  </span>
                </p>
              </div>
            </div>
            <div style={styles.orderBottom}>
              <p style={{ display: 'flex' }}>
                Receiver Signature
                <span style={{ paddingLeft: '30px', fontWeight: '800', paddingRight: '30px' }}>
                  {/* Handle decoding logic for the signature image */}
                  {(() => {
                    let signatureImage = orderDetail?.signature_img;
                    console.log("signature image",signatureImage)
                    if (
                      signatureImage &&
                      signatureImage.startsWith(
                        "https://easepharmbucket.s3.amazonaws.com/https%3A"
                      )
                    ) {
                      signatureImage = decodeURIComponent(
                        signatureImage.replace(
                          "https://easepharmbucket.s3.amazonaws.com/",
                          ""
                        )
                      );
                      console.log("decoded signature_img", signatureImage);
                    }

                    // Render the signature image if it exists
                    return signatureImage ? (
                      <img
                        style={{ height: '35px', width: '90px' }}
                        src={signatureImage}
                        alt="signature"
                      />
                    ) : null;
                  })()}
                </span>
              </p>

              <p>
                Delivered by
                <span
                  style={{
                    paddingLeft: '30px',
                    fontWeight: '800',
                    paddingRight: '30px',
                    borderBottom: '1px solid black',
                  }}
                >
                  {pharmacy?.delivered_by === 'PD'
                    ? 'PD'
                    : pharmacy?.delivered_by === 'Driver'
                      ? orderDetail?.driver
                      : ''}
                </span>
              </p>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Printdoc;
